import NextHead from 'next/head'
import { useRouter } from 'next/router'
import { NextSeo } from 'next-seo'

const isProduction = process.env.NODE_ENV === 'production'

interface Props {
  children?: JSX.Element[] | JSX.Element
  title: string
  description?: string
}

export const Head: React.FC<Props> = ({ children, title, description }: Props) => {
  const { asPath } = useRouter()
  return (
    <>
      <NextHead>
        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta httpEquiv="x-ua-compatible" content="ie=edge" />
        <meta name="theme-color" content="#572DFF"></meta>
        <link rel="shortcut icon" href="/favicon.png" />

        {children}
      </NextHead>

      <NextSeo
        title={title.length ? `Good Neighbour | ${title}` : 'Good Neighbour'}
        description={description || 'Read real testimonials from people who have lived in the same rental as you.'}
        canonical={`https://goodnbr.co${asPath}`}
        openGraph={{
          url: `https://goodnbr.co${asPath}`,
          title: title.length ? `Good Neighbour | ${title}` : 'Good Neighbour',
          description: description || 'Read real testimonials from people who have lived in the same rental as you.',
          images: [
            {
              url: 'https://goodnbr.co/og/gn-og1.png',
              width: 1012,
              height: 506,
              alt: 'Good Neighbour Promo',
              type: 'image/png',
            },
            {
              url: 'https://goodnbr.co/og/gn-og2.png',
              width: 1012,
              height: 506,
              alt: 'Good Neighbour Promo',
              type: 'image/png',
            },
            {
              url: 'https://goodnbr.co/og/gn-og3.png',
              width: 1012,
              height: 506,
              alt: 'Good Neighbour Promo',
              type: 'image/png',
            },
            {
              url: 'https://goodnbr.co/og/gn-og4.png',
              width: 1012,
              height: 506,
              alt: 'Good Neighbour Promo',
              type: 'image/png',
            },
          ],
          site_name: 'GoodNeighbour',
        }}
        twitter={{
          handle: '@goodnbrco',
          site: '@site',
          cardType: 'summary_large_image',
        }}
      />
    </>
  )
}
